import React from 'react'

export default function NoDataError({tag}) {
  return (
    <main className="mx-auto flex text-center w-full max-w-7xl flex-auto flex-col justify-center">
      <p className="text-xl font-avenir-medium leading-8 text-primary-blue">
        404
      </p>
      <h1 className="mt-4 text-3xl font-avenir-black tracking-tight text-gray-900 sm:text-5xl">
        No {tag} found
      </h1>
      <p className="my-3 text-base leading-7 text-gray-600">
        Please contact Credit Key support.
      </p>
      <div
        onClick={() => (window.location.href = `/`)}
        className="text-primary-blue cursor-pointer"
      >
        <button
          type="button"
          className="rounded bg-light-blue py-2 px-3 text-sm font-semibold text-primary-blue shadow-sm hover:bg-navy-blue hover:text-white"
        >
          <p>Back to Search</p>
        </button>
      </div>
    </main>
  )
}
